module.exports = __webpack_public_path__ + "img/icon1.e636b402.svg";